import fileSys from "../../fileoprators/fileSystem";
import SettingsOprator from "../settingsoprator";
import { ZERNIKEPARAMS } from "../consts";
const DEFAULTSET = ZERNIKEPARAMS;
class ZernikeParams extends SettingsOprator {
  constructor() {
    super(fileSys.getTopographyCfgPath("zernikeParamsSettings.json"), DEFAULTSET);
  }
  getSZernikeParamsettings() {
    return this.getSettings();
  }
  saveZernikeParamsSettings(settings) {
    this.saveSettings(settings);
  }
}
export default ZernikeParams;



// WEBPACK FOOTER //
// ./src/settings/topography/zernikeParams.js